<template>
  <div class="db-app db-layout-grid-wrapper">
    <component :is="vueComponent" />
  </div>
</template>

<script setup lang="ts">
// App is the common wrapper ensuring all elements are
// inside the class "db-app"

import { defineAsyncComponent } from 'vue'
import type { Component } from 'vue'

const props = defineProps<{
  mainComponent: () => Promise<Component>
}>()

const vueComponent: Component = defineAsyncComponent(props.mainComponent)
</script>
